import { MatchSocketRepository } from "../repositories/SocketRepository";

export class ConnectSocketMatch {
	constructor(private repository: MatchSocketRepository) {}
	execute(): Promise<void> {
		return this.repository.connectSocket();
	}
}
